/**
 * 车辆诊断-合同记录
 */
import dayjs from 'dayjs';
import React, { useEffect, useState } from "react";
import { Button, Drawer, Timeline, Divider, Popconfirm, message } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { DeleteContract, contractListRequest } from '@/service/contractManage'
import OperateModal from '../../../contractManage/components/operateModal';
import PermissionButton from '@/components/permissionButton';
import LoadingWrapper from '@/components/loadingWrapper';
import ContractItem from '../contractItem';
import styles from './index.module.scss';

interface ContractRecordProps {
  carInfo: any; // 车辆信息
  onClose: () => void; // 关闭合同记录弹层的方法
}
const ContractRecoed = (props: ContractRecordProps) => {
  const { carInfo, carInfo: { plate_number, id }, onClose } = props;
  const [page, setPage] = useState(1); // 页码
  const [totalCount, setTotalCount] = useState(0); // 总数
  const [recordData, setRecordData] = useState<any>([]); // 合同记录数据
  const [loading, setLoading] = useState<boolean>(false) // 合同记录数据是否在请求中
  const [addContract, setAddContract] = useState<any>({}); // 合同记录操作相关的信息

  // 获取合同记录
  const getContractRecord = async (newPage: number) => {
    try {
      setLoading(true);
      const res = await contractListRequest({ limit: 40, page: 1, plateNumber: plate_number });
      const data = res.data?.data || [];
      if (newPage === 1) {
        setRecordData(data);
      } else {
        setRecordData([...recordData, ...data]);
      }
      setPage(newPage);
      setLoading(false);
      setTotalCount(res.data?.count || 0);
    } catch (error) {
      setLoading(false);
    }
  }

  useEffect(() => {
    getContractRecord(1);
  }, []);

  // 加载更多
  const loadMore = () => {
    getContractRecord(page + 1);
  }

  // 删除合同记录
  const deleteRecord = async (id: number) => {
    const res = await DeleteContract(id);
    if (res.data?.code === 0) {
      message.success('删除成功');
      getContractRecord(1);
    }
  }

  // 车辆诊断新增合同
  const onContractAdd = async () => {
    setAddContract({ type: 'add', data: {plateNumber:carInfo.plate_number,frameNumber:carInfo.frame_number}});
  }

  const getData = () => {
    getContractRecord(1);
  }

  return (
    <Drawer
      title={`${plate_number}合同记录`}
      visible
      onClose={onClose}
      className={styles.recordDrawer}
      size="large"
    >
      <PermissionButton
        type='primary'
        style={{ marginBottom: '16px' }}
        onClick={() => onContractAdd()}
        operateType='/car-admin/car-diagnose/contract-add'
      >
        新增合同记录
      </PermissionButton>
      <LoadingWrapper spinning={loading}>
        <Timeline>
          {recordData.map((item: any) => {
            return (
              <Timeline.Item>
                <div>
                  {item.createdAt ? dayjs(item.createdAt).format('YYYY-MM-DD HH:mm:ss') : item.createdAt}
                  <Popconfirm
                    title="此操作将删除该条合同记录, 是否继续?"
                    onConfirm={() => deleteRecord(item.id)}
                  >
                    <PermissionButton
                      operateType='/car-admin/car-diagnose/contract-delete'
                      type="link"
                      style={{ padding: '0 0 0 6px', height: '26px' }}
                    >
                      <DeleteOutlined style={{ color: 'red' }} />
                    </PermissionButton>
                  </Popconfirm>
                </div>
                <ContractItem column={{ xs: 1, sm: 2 }} data={item} type="Contract" />
              </Timeline.Item>
            )
          })}
        </Timeline>
        {recordData.length ?
          <Divider plain>
            {totalCount > recordData.length ?
              <Button type="primary" onClick={loadMore}>加载更多</Button> :
              "已加载全部数据"
            }
          </Divider> :
          <Divider plain>暂无合同记录</Divider>
        }
      </LoadingWrapper>
      {['add'].includes(addContract?.type) &&
        <OperateModal
          type={addContract.type}
          data={addContract.data}
          closeModal={() => setAddContract({})}
          reloadData={getData}
        />
      }
    </Drawer>
  )
}

export default ContractRecoed;